/* eslint-disable @typescript-eslint/naming-convention */

export const TITLE_LOGO_CONFIG = {
    LITE: {
        height: "19px",
        width: "83px",
    },
    PLUS: {
        height: "19px",
        width: "43px",
    },
};

export const ONE_BLACK_LOGO_CONFIG = {
    height: "22px",
    width: "52px",
};

export const A11Y_LOGO_REPLACEMENTS = {
    ONE: "One",
    LITE: "One Lite",
    BLACK: "Black",
};

export const DELIVERY_TAG_COLORS = {
    LOW: {
        pillBgColor: "highlight_Sub",
        textColor: "highlight",
    },
    HIGH: {
        pillBgColor: "positive_Sub",
        textColor: "positive",
    },
};

export const NUDGE_TYPES = {
    REGULAR: "NUDGE_TYPE_REGULAR",
    ONE_TAP: "NUDGE_TYPE_ONE_TAP",
};

export const BG_GRADIENTS = {
    RED: "linear-gradient(300deg,#f9ab92bf -10%,#fff 30%)",
    GREEN: "linear-gradient(253.45deg,#e3fff5 2%,#ffffff 35.44%)",
    YELLOW: "linear-gradient(254.59deg,#fff7e1 0%,#ffffff 40.77%)",
    PEACH: "linear-gradient(180deg, #FFF 30.85%, #FFEEE5 184.15%)",
    BROWN_LEFT: "linear-gradient(265deg, #FFF 34.03%, #EFE4DE 96.77%)",
    BROWN_TOP_RIGHT: "linear-gradient(211.54deg, #D9BDAF -77.44%, #FFFFFF 72.36%)",
    BROWN: "linear-gradient(281.91deg, #D9BDAF -113.63%, #FFFFFF 105.73%)",
};

export const BOTTOMSHEET_CTAS_TEXTS = {
    PRIMARY: "Keep It",
    PRIMARY_ANIMATION: "Pay less with Swiggy One",
    SECONDARY: "Remove membership",
};

export const BOTTOMSHEET_BLCK_CTAS_TEXTS = {
    PRIMARY: "I’ll stay a BLCK member",
    SECONDARY: "Remove membership",
};

export const BOX_SHADOW = "0 1px 16px rgba(0, 0, 0, 0.05)";
export const RUPEE_SYMBOL = "₹";
export const containerIDForDLSPlanRemovalBottomsheet = "swiggy-one-dls-plan-removal-bs-container";

// This is needed for Analytics
export const GRATIFICATION_CLOSE_BUTTON = {
    CTA_CLICK: "cta_click",
    DISMISS_BUTTON: "dismiss_button",
    AUTO_COLLAPSE: "auto_collapse",
};

export const ONELOGO_LINK = {
    ONE: "portal/c/OneBGLogo.png",
    BLACK: "BLCK/IM%20cart%20logo%20bg.png",
};
